module.exports = __webpack_public_path__ + "static/media/techLead.d405f55e.png";